import React, { CSSProperties } from 'react';
import styled, { css } from 'styled-components';

export interface ApiKeyPreviewStyleProps {
  isEmpty: boolean;
}

export interface ApiKeyPreviewProps extends Partial<ApiKeyPreviewStyleProps> {
  className?: string;
  prefix?: string;
  value?: string;
  placeholder?: string;
  style?: CSSProperties;
}

const StyledApiKeyPreview = styled.div<ApiKeyPreviewStyleProps>`
  display: flex;
  align-items: center;
  gap: 1px;
  color: ${({ theme }) => theme.secondary.background};
  font-size: 12px;
  font-weight: 500;
  line-height: 24px;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;

  ${({ isEmpty }) =>
    isEmpty &&
    css`
      color: ${({ theme }) => theme.secondary.blendToBackground(400)};
    `}
`;

const Dots = styled.span`
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  font-size: 9px;
  letter-spacing: 1px;
`;

const MONO = "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace";

const Prefix = styled.span`
  flex: none;
  font-family: ${MONO};
`;

const Last4 = styled.span`
  flex: none;
  font-family: ${MONO};
`;

const DOTS = '•'.repeat(4);

export const ApiKeyPreview: React.FC<ApiKeyPreviewProps> = (props) => {
  const styleProps: ApiKeyPreviewStyleProps = {
    isEmpty: !props.value,
  };

  if (!props.value) {
    return (
      <StyledApiKeyPreview style={props.style} className={props.className} {...styleProps}>
        {props.placeholder}
      </StyledApiKeyPreview>
    );
  }

  return (
    <StyledApiKeyPreview style={props.style} className={props.className} {...styleProps}>
      {props.prefix && <Prefix>{props.prefix}</Prefix>}
      <Dots aria-hidden>{DOTS}</Dots>
      <Last4>{props.value}</Last4>
    </StyledApiKeyPreview>
  );
};
